import { IGetUserNotificationSettingsQuery } from "api/queries/usersAPI";

export const groupMachineCentersByProductionLine = (
    data: IGetUserNotificationSettingsQuery["user_notification_settings"][0]["user_machine_center_notification_settings"],
) => {
    return data.reduce(
        (
            acc: {
                production_line_id: number;
                name: string;
                machine_centers: {
                    machine_center_id: number;
                    name: string;
                    is_enabled: boolean;
                }[];
            }[],
            item,
        ) => {
            const { production_line, machine_center_id, name } = item.machine_center;
            const { is_enabled } = item;

            const existingLine = acc.find((line) => line.production_line_id === production_line.production_line_id);

            if (existingLine) {
                existingLine.machine_centers.push({ machine_center_id, name, is_enabled });
            } else {
                acc.push({
                    production_line_id: production_line.production_line_id,
                    name: production_line.name,
                    machine_centers: [{ machine_center_id, name, is_enabled }],
                });
            }

            return acc;
        },
        [],
    );
};
